import {ValidationResult} from "./validation-result";

export interface ServiceRequestType {
    id: number;
    description: string;
    flatRequestField: string;
    primaryServiceFlag: number;
    unitOfMeasure: string;
    baseDurationDays: number;
    activeStatus: string;
    externalReferral: string;
    defaultMembers: string;
}

export class ServiceRequestType {
    constructor() {
        this.id = 0;
        this.description = '';
        this.primaryServiceFlag = 0;
        this.unitOfMeasure = '';
        this.baseDurationDays = 0;
        this.activeStatus = '';
        this.externalReferral ='No';
        this.defaultMembers='A';
    }
    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();


        if(this.description.length < 4) {
            vr.focus_field = 'description';
            vr.error = 'Error: A description is required (must be at least 4 characters)';
            return vr;
        }
        if(this.flatRequestField.length < 4) {
            vr.focus_field = 'flatRequestField';
            vr.error = 'Error: A Jotform request name is required (must be at least 4 characters)';
            return vr;
        }

        if(this.unitOfMeasure.length ===0) {
            vr.focus_field = 'unitOfMeasure';
            vr.error = 'Error: A unit of measure is required';
            return vr;
        }
        if(!this.baseDurationDays || this.baseDurationDays === 0) {
            vr.focus_field = 'baseDurationDays';
            vr.error = 'Error: Assessment Period days must be greater than zero (0)';
            return vr;
        }
        return vr;
    }
}
